import { useState, useEffect } from 'react';
import { leadsApi } from '../services/leads.api';
import { STATUSES } from '../lib/constants';
import LeadScoreBadge from '../components/leads/LeadScoreBadge';
import { useNavigate } from 'react-router-dom';

const PIPELINE_STAGES = ['New','Contacted','Follow-up','Call Booked','Proposal Sent','Negotiating','Won','Lost'];

export default function Pipeline() {
  const [leads, setLeads] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    leadsApi.list({ limit: 200 }).then(r => setLeads(r.data.data || r.data));
  }, []);

  const byStage = (stage) => leads.filter(l => l.status === stage);

  const onDrop = async (leadId, newStatus) => {
    setLeads(ls => ls.map(l => l.id === leadId ? { ...l, status: newStatus } : l));
    await leadsApi.update(leadId, { status: newStatus });
  };

  return (
    <div className="flex gap-3 overflow-x-auto pb-2 h-full">
      {PIPELINE_STAGES.map(stage => {
        const stageleads = byStage(stage);
        return (
          <div key={stage}
            className="shrink-0 w-52 flex flex-col bg-zinc-100 rounded-lg"
            onDragOver={e => e.preventDefault()}
            onDrop={e => { e.preventDefault(); const id = e.dataTransfer.getData('leadId'); if (id) onDrop(id, stage); }}>
            <div className="px-3 py-2 flex items-center justify-between">
              <span className="text-xs font-semibold text-zinc-700">{stage}</span>
              <span className="text-xs text-zinc-400 bg-zinc-200 px-1.5 py-0.5 rounded-full">{stageleads.length}</span>
            </div>
            <div className="flex-1 overflow-y-auto px-2 pb-2 space-y-2">
              {stageleads.map(lead => (
                <div key={lead.id}
                  draggable
                  onDragStart={e => e.dataTransfer.setData('leadId', lead.id)}
                  onClick={() => navigate(`/leads/${lead.id}`)}
                  className="bg-white border border-zinc-200 rounded-md p-2.5 cursor-pointer hover:shadow-sm transition-shadow">
                  <p className="text-xs font-semibold text-zinc-800 truncate">{lead.company_name}</p>
                  <p className="text-xs text-zinc-400 truncate mt-0.5">{lead.contact_name}</p>
                  {lead.lead_score != null && (
                    <div className="mt-1.5"><LeadScoreBadge score={lead.lead_score} /></div>
                  )}
                  {lead.assigned_to && (
                    <p className="text-xs text-zinc-400 mt-1">{lead.assigned_to}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
